module.exports = __webpack_public_path__ + "static/media/Miracle Girls - Box Cover.63719942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/box/Miracle Girls - Box Cover.jpg
// module id = 93
// module chunks = 0